import React,
{
	useRef,
	useState,
	useEffect
}
	from "react"
import { menuDelPlantel, usePlantelesCatalogoCerrado } from "./components/catalogoViejoCerrado"
import WappIcono from "./components/wappIcono"
import StagingBanner
	from "./components/stagingBanner"
import {
Route,
Routes,
Navigate,
Link,
useLocation,
useNavigate
}
	from "react-router-dom"
import Modal
	from "react-modal"
import {
useSelector,
useDispatch
}
	from "react-redux"
import { Popover }
	from "react-tiny-popover"
import { FontAwesomeIcon }
	from "@fortawesome/react-fontawesome"
import {
solid,
regular
}
	from "@fortawesome/fontawesome-svg-core/import.macro"
import _
	from "lodash"

import
store, {
	RootState,

	displayNotice,
	dismissNotice,

	enableIdleLockSwitch,
	disableIdleLockSwitch,

	setSessionToken,
	setAuthenticated,
	toggleTheme,
	setUserProfile,
	setCurrentUserRole,
	setCurrentUserCampus,
	setCurrentUserCampusId,
	setCampusRef,

	setUserMenu,
	setMenuRef,
	setNavigation
}
	from "./globals"
import useClickOutsideRef,
{
	themes,
	UIState,
	baseNavigation,
	studentMenu,
	studentNavigation,
	basicSetup,
	baseMenu,
	isNotEmpty,
	generateSectionMap
}
	from "./common"
import AuthService
	from "./services/auth.service"
import MiNombre
	from "./components/miNombre/miNombre"
import {nombrePersonal}
	from "./utils/nombreCorto"
import CustomIcon
	from "./components/customIcon"
import { UserPrompt }
	from "./components/sectionContainer"
import Access
	from "./navigation/access"
import {avatarPorDefecto}
	from "./utils/avatarPorDefecto"
import logoMenu
	from "./assets/images/logoMenu.png"
/*
	El lockup de Washington Academy lleva aguila roja y letrero azul marino: sobre
	la barra lateral oscura el azul se pierde y el conjunto se ve sucio. El kit de
	marca trae la version blanca justo para eso, asi que en modo oscuro se usa esa.
	(Esteban, 2026-09-20)
*/
import logoMenuBlanco
	from "./assets/images/logoMenuBlanco.png"
import {plantelMedio, plantelSiglas}
	from "./utils/plantelCorto"
import wappWordmark
	from "./assets/images/wappWordmarkNaranja.svg"

import "./style.css"
import "./assets/css/app.css"
import { tunning } from "./constants"
import {
	setCurrentCampusId,
	setCurrentRole,
	setAllowedCampuses,
	setCurrentCampus,
	setUser,
	UserState,
	setPermissions,
	handleLogout
} from "./redux/reducers/sessionReducer";
import HttpManager from "./services/HttpManager"
import { setCampuses, setPaymentMethods } from "./redux/reducers/catalogReducer"
import { useAxiosInterceptor } from "./services/v2/axiosInstance"
import { ReactNode } from "react"
import WappTeamDock from "./navigation/v2/sales/wappteamDock"
import { anotarDuenoDelToken, borrarSesionLocal, recordarDestino } from "./guardiaDeSesion"
import VisorDeArchivos from "./components/enrollment/visorArchivo"
import CambioDeClaveObligatorio, { marcarCambioDeClave } from "./cambioDeClave"
import { TelefonoGlobal } from "./navigation/v2/sales/telefono/telefonoUI"
import LlamadasEquipo from "./navigation/v2/sales/llamadasEquipo"
import AppMovilView from "./appMovil/appMovilView"
import AppMovilGlobal from "./appMovil/appMovilGlobal"
import { olvidarEsteAparato } from "./appMovil/appMovil"
import ContadoresBarra, { Globito } from "./appMovil/contadoresBarra"
import { CorreoNoLeidos } from "./correo/correoNoLeidos"
import { useNoLeidosCorreo } from "./correo/noLeidos"
import AvisosView from "./avisos/avisosView"
import AvisosEnVivo from "./avisos/avisosEnVivo"
import FestejoMatricula from "./festejo/festejoMatricula"
import { useContadores } from "./appMovil/contadores"
import { push } from "./navigation/v2/sales/push"
import { guardarDestino, tomarDestino, verDestino } from "./utils/destinoTrasLogin"


const IrAlLogin = () => { recordarDestino(); guardarDestino(); return <Navigate to="/access" replace /> }

const PrivateRoute = ({ authenticated, children }: { authenticated: boolean; children: any }) => {
	if (!authenticated) {
		recordarDestino()   // producción: el login regresa a este enlace (wapp.volverA)
		guardarDestino()    // cobros: si al entrar el menú todavía no trae la ruta (o pide otro rol con «rol=»), App la retoma
		return <Navigate to="/access" replace />
	}

	return children
}

/* Ruta desconocida: sin sesión, guarda a dónde iba (enlace directo) y manda a iniciar sesión. */
const IrAlInicio = ({ authenticated }: { authenticated: boolean }) => {
	// Sin sesión, o con sesión en un rol que no tiene esa pantalla pero el enlace trae «rol=» (Cliq): se guarda a dónde iba; App
	// cambia de rol si hace falta y lo retoma.
	if (!authenticated || new URLSearchParams(window.location.search).get("rol")) {
		guardarDestino()
	}
	return <Navigate to={authenticated ? "/" : "/access"} />
}

/*
	Contadores del menú (cobros, Etapa 4): Descuentos = casos «Por resolver» de grupos (decisión 14); Auditoría = casos por
	auditar; Preguntas de Auditoría = las que esperan MI respuesta (o la de mi equipo, en copia). Si la persona no tiene la
	sección, el servidor dice que no y no sale nada.

	Compartidos (26-oct-2026): cada sección del menú y cada pestaña pedía los suyos, y con el aviso «aviso» se pedían todos a la
	vez; eran los únicos «Demasiados intentos» que quedaban con el límite de 300/min por sesión. Ahora hay UNA cuenta por plantel
	y contador para toda la app: se pide como mucho una vez por minuto entre todas las pestañas (la hora y el número viven en
	localStorage, y las demás pestañas se enteran con el evento «storage»); un error deja el número de antes.
	Sin setInterval: el aviso «aviso» (Centro de Avisos) vuelve a pedir, porque los pedidos de descuento y las preguntas de
	Auditoría llegan por ahí a quien los atiende. NO se escucha «conteos»: es del CRM (llega con cada WhatsApp de la cartera);
	escucharlo pidió 3,500 conteos en 2 min el 23-oct-2026.
*/
// Por Resolver pasó de Descuentos a Promociones (Módulos Claros, 2026-11-01): el número sale en Promociones.
const RUTAS_CON_CONTADOR: string[] = ["promoApplications", "audits", "auditQuestions"]
const CONTADOR_CADA = 60000
/*
	Por Resolver solo lo ven Caja, Supervisión y Dirección: la asesora siempre recibiría 0 y cada pedido le cuesta al servidor varias
	consultas. Se pide el número solo si el rol es de supervisión o dirección (ROLES_VEN_TODO del servidor, 0 = superadmin) o si
	cleanupAccess dice canSee (Caja y quien tiene el catálogo); esa respuesta se guarda por plantel y rol mientras la pestaña esté abierta.
*/
const ROLES_SUPERVISION: number[] = [0, 5, 7, 33, 34, 41, 42]
const accesoPromociones: Record<string, Promise<boolean>> = {}
const verPorResolver = (campusId: number, rolId: number | null): Promise<boolean> => {
	if (rolId !== null && ROLES_SUPERVISION.includes(rolId)) return Promise.resolve(true)
	const llave = campusId + "." + rolId
	if (!accesoPromociones[llave]) {
		accesoPromociones[llave] = HttpManager.getInstance().paymentService.cleanupAccess(campusId).then((r: any) => !!r.data?.canSee)
			.catch((e: any) => { delete accesoPromociones[llave]; throw e })
	}
	return accesoPromociones[llave]
}
const pedirCuenta: Record<string, (campusId: number, rolId: number | null) => Promise<number>> = {
	promoApplications: (c, rolId) => verPorResolver(c, rolId).then((ve) => ve ? HttpManager.getInstance().paymentService.discountGroupsCount(c).then((r: any) => Number(r.data.open || 0)) : 0),
	audits: (c) => HttpManager.getInstance().paymentService.auditCounts(c).then((r: any) => Number(r.data.total || 0) + Number(r.data.escalados || 0)),
	auditQuestions: (c) => HttpManager.getInstance().paymentService.auditQuestionsCount(c).then((r: any) => Number(r.data.open || 0)),
}
const cuentasMenu: Record<string, { n: number | null; at: number; enCamino: boolean }> = {}
const oyentesMenu = new Set<() => void>()
const llaveContador = (campusId: number, ruta: string): string => "wapp.contador." + campusId + "." + ruta
const leerContador = (campusId: number, ruta: string): { n: number | null; at: number } | null => {
	try { const v = JSON.parse(localStorage.getItem(llaveContador(campusId, ruta)) || "null"); return v && typeof v.at === "number" ? v : null } catch { return null }
}
const guardarContador = (campusId: number, ruta: string, n: number | null, at: number): void => {
	try { localStorage.setItem(llaveContador(campusId, ruta), JSON.stringify({ n, at })) } catch { /* sin localStorage: solo esta pestaña */ }
}
const avisarContadores = (): void => { oyentesMenu.forEach((f) => f()) }
/** Pide un contador si nadie (ninguna sección ni pestaña) lo pidió en el último minuto; si no, usa el número que ya hay. */
const pedirContador = (campusId: number, ruta: string, rolId: number | null): void => {
	const k = llaveContador(campusId, ruta)
	const c = cuentasMenu[k] || (cuentasMenu[k] = { n: null, at: 0, enCamino: false })
	const otra = leerContador(campusId, ruta)
	if (otra && otra.at > c.at) { c.at = otra.at; if (otra.n !== null) { c.n = otra.n; avisarContadores() } }
	if (c.enCamino || Date.now() - c.at < CONTADOR_CADA) return
	// Se aparta el turno antes de pedir, para que otra pestaña que despierta a la vez no pida lo mismo.
	c.at = Date.now()
	c.enCamino = true
	guardarContador(campusId, ruta, c.n, c.at)
	pedirCuenta[ruta](campusId, rolId)
		.then((n) => { c.n = n; c.at = Date.now(); guardarContador(campusId, ruta, n, c.at); avisarContadores() })
		.catch(() => { /* «Demasiados intentos» u otro: se queda el número de antes; se vuelve a pedir en un minuto */ })
		.finally(() => { c.enCamino = false })
}
if (typeof window !== "undefined") {
	window.addEventListener("storage", (e) => {
		if (!e.key || !e.key.startsWith("wapp.contador.") || !e.newValue) return
		try {
			const v = JSON.parse(e.newValue)
			const c = cuentasMenu[e.key] || (cuentasMenu[e.key] = { n: null, at: 0, enCamino: false })
			if (typeof v.at === "number" && v.at >= c.at) { c.at = v.at; if (v.n !== null && v.n !== undefined) c.n = Number(v.n); avisarContadores() }
		} catch { /* valor raro: se ignora */ }
	})
}
const useContadoresMenu = (rutas: string[]): Record<string, number> => {
	const campusId: number = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampusId)
	const rolId: number | null = useSelector((state: RootState) => state.rootReducer.sessionState.currentRole?.id ?? null)
	const firma: string = rutas.filter((r) => RUTAS_CON_CONTADOR.includes(r)).join(",")
	const [, setVuelta] = useState<number>(0)
	useEffect(() => {
		if (!campusId || firma === "") return
		const propias = firma.split(",")
		const pedir = () => propias.forEach((r) => pedirContador(campusId, r, rolId))
		const repintar = () => setVuelta((v) => v + 1)
		oyentesMenu.add(repintar)
		pedir()
		// Varios avisos seguidos se juntan en uno; pedirContador ya no deja pedir más de una vez por minuto entre todos.
		let espera: any = null
		const pronto = () => {
			if (espera) return
			// Si ya se pidió hace menos de un minuto, se espera a que se cumpla (el aviso trae algo nuevo que hay que ver).
			const falta = Math.max(0, ...propias.map((r) => CONTADOR_CADA - (Date.now() - (cuentasMenu[llaveContador(campusId, r)]?.at || 0))))
			espera = setTimeout(() => { espera = null; pedir() }, falta + 1200 + Math.round(Math.random() * 1500))
		}
		const soltar = push.usar(campusId)
		const quitar = [push.on("aviso", pronto)]
		return () => { quitar.forEach((f) => f()); soltar(); clearTimeout(espera); oyentesMenu.delete(repintar) }
	}, [campusId, firma, rolId])
	const cuentas: Record<string, number> = {}
	if (campusId && firma !== "") {
		firma.split(",").forEach((r) => { const c = cuentasMenu[llaveContador(campusId, r)]; if (c && c.n !== null) cuentas[r] = c.n })
	}
	return cuentas
}

const Accordion =
	(
		{ block, content, currentRoute }: { block: any; content: { display: string; route: string; under?: string | null }[]; currentRoute: string }
	) => {
		const [isActive, setIsActive] = useState(false)
		const contadoresMenu: Record<string, number> = useContadoresMenu(content.map((c) => c.route))
		const totalContadores: number = Object.values(contadoresMenu).reduce((a, b) => a + b, 0)
		const pastilla = (n: number) => n > 0
			? <span style={{ marginLeft: 6, background: "var(--wa-oro-suave)", color: "var(--wa-oro)", borderRadius: 999, padding: "0 7px", fontSize: 12, fontWeight: 700 }}>{n}</span>
			: null
		const icons: any = [solid("chevron-up"), solid("chevron-down")]
		const menuRef: any = useSelector((state: RootState) => state.menuRef.value)
		const idleLocked: boolean = useSelector((state: RootState) => state.idleLockSwitch.value)
		// Globitos rojos de WappChat y WappTeam: en su renglón, y la suma en el grupo mientras está cerrado.
		const contadores = useContadores()
		const correoNoLeidos = useNoLeidosCorreo()
		const pendientes = (route: string): number => route == "wappchat" ? (contadores.wappchat || 0) : route == "wappteam" ? contadores.wappteam : route == "wappmail" ? correoNoLeidos : 0
		const delGrupo = content.reduce((t, x) => t + pendientes(x.route), 0)

		return <tbody>
			<tr onClick={() => setIsActive(!isActive)} style={{ background: "var(--wa-superficie)", color: "var(--wa-tinta)", cursor: "pointer" }}>
				<td style={{ width: "74px", textAlign: "center", paddingLeft: "30px", color: "var(--wa-apagado)" }} className="xsDisposable">
					<CustomIcon name={block.icon} style={{ fill: (menuRef[currentRoute] != block.group ? "var(--wa-apagado)" : "var(--wa-acento)") }} />
				</td>
				<td style={{ padding: "10px 0px 10px 4px", color: (menuRef[currentRoute] != block.group ? "var(--wa-apagado)" : "var(--wa-acento)") }}><b>
					{block.display}
				</b>{isActive ? null : <><Globito n={delGrupo} className="menu-globito" />{pastilla(totalContadores)}</>}</td>
				<td className="xsDisposable" style={{ textAlign: "right", paddingRight: "34px" }}>
					<FontAwesomeIcon icon={icons[+isActive]} />
				</td>
			</tr>
			{
				!isActive ? "" : content.map
					(
						({ display, route, under }: { display: string; route: string; under?: string | null }) => <tr key={block.display + "." + display}
							style={{ background: (route == currentRoute ? "var(--wa-acento-suave)" : "var(--wa-superficie)"),
								color: (route == currentRoute ? "var(--wa-acento)" : "var(--wa-apagado)"),
								fontWeight: (route == currentRoute ? 800 : 500),
								boxShadow: (route == currentRoute ? "inset 3px 0 0 var(--wa-acento)" : "none") }}
						>
							<td style={{ textAlign: "right", paddingRight: "5px" }} className="xsDisposable" />
							{/* Las secciones que cuelgan de otra salen indentadas (Esteban, 2026-09-22). */}
							<td colSpan={2} style={{ padding: "5px 20px 5px " + (under ? 26 : 8) + "px" }}>{
								idleLocked
									?
									<div style={{ fontWeight: route == currentRoute ? "500" : "300" }}>
										{display}<Globito n={pendientes(route)} className="menu-globito" />{pastilla(contadoresMenu[route] || 0)}
									</div>
									:
									<Link to={route}>
										<div style={{ fontWeight: route == currentRoute ? "500" : "300" }}>
											{display}<Globito n={pendientes(route)} className="menu-globito" />{pastilla(contadoresMenu[route] || 0)}
										</div>
									</Link>
							}</td>
						</tr>
					)
			}
		</tbody>
	}

const App = () => {
	useAxiosInterceptor();

	const http = HttpManager.getInstance();
	const dispatch: any = useDispatch()
	const navigate: any = useNavigate()
	const currentCampusId: number = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampusId);
	const userData: UserState | null = useSelector((state: RootState) => state.rootReducer.sessionState.user);
	//Planteles con el Catálogo viejo cerrado: los manda el backend (Módulos Claros, 2026-11-01).
	usePlantelesCatalogoCerrado(!!userData?.token);
	const allowedCampuses: any[] = useSelector((state: RootState) => state.rootReducer.sessionState.allowedCampuses);
	const currentCampus: any = useSelector((state: RootState) => state.rootReducer.sessionState.currentCampus);
	const campuses: any[] = useSelector((state: RootState) => state.rootReducer.catalog.campuses);
	const roles: any[] = useSelector((state: RootState) => state.rootReducer.sessionState.roles);
	const currentRole = useSelector((state: RootState) => state.rootReducer.sessionState.currentRole);
	const esSoloAlumno: boolean = !roles || roles.length === 0

	const userProfile: any = useSelector((state: RootState) => state.userProfile.value)
	const currentUserCampus: any = useSelector((state: RootState) => state.currentUserCampus.value)
	const campusRef: any = useSelector((state: RootState) => state.campusRef.value)
	const sessionToken: string | null = useSelector((state: RootState) => state.sessionToken.value)
	const authenticated: boolean = useSelector((state: RootState) => state.authenticated.value)
	const userMenu: any = useSelector((state: RootState) => state.userMenu.value)
	const navigation: any = useSelector((state: RootState) => state.navigation.value)
	const basicInfo: any = useSelector((state: RootState) => state.basicInfo.value)
	const ubicacion = useLocation()
	const location: string = ubicacion.pathname.substr(1)
	const idleLocked: boolean = useSelector((state: RootState) => state.idleLockSwitch.value)
	//const [themeToggle, setThemeToggle] = useState(useSelector((state : RootState) => state.themeToggle.value));
	const [unfilledFields, setUnfilledFields] = useState<boolean>(false)
	const [noCityProvided, setNoCityProvided] = useState<boolean>(false)
	const [campusesListShown, setCampusesListShown] = useState<boolean>(false)
	const [appLoaded, loadApp] = useState<boolean>(false)
	const [UIStatus, setUIStatus] = useState<number>(UIState.NORMAL)
	const [saveError, setSaveError] = useState<any>(null)
	const [roleListShown, roleListDisplay] = useState<boolean>(false)
	const [userProfileOptionsShown, setUserProfileOptionsShown] = useState<boolean>(false)
	// Cambiar la foto propia desde el menú (Esteban, 2026-10-10: "desde dónde lo pueden agregar ellas").
	const [fotoAviso, setFotoAviso] = useState<string | null>(null)
	const [subiendoFoto, setSubiendoFoto] = useState<boolean>(false)
	const cambiarFoto = async (e: React.ChangeEvent<HTMLInputElement>) => {
		const f = e.target.files?.[0]
		e.target.value = ""
		if (!f) return
		if (f.size > 5 * 1024 * 1024) { setFotoAviso("La foto pesa más de 5 MB. Elige una más ligera."); return }
		setSubiendoFoto(true); setFotoAviso(null)
		try {
			const r: any = await AuthService.saveCurrentUserPhoto(f)
			dispatch(setUserProfile({ ...userProfile, image: r.data.image }))
			setFotoAviso("Listo, ya tienes foto.")
		} catch (err: any) {
			setFotoAviso(err?.response?.data?.message || "No se pudo cambiar la foto. Intenta con otra imagen (JPG o PNG).")
		} finally { setSubiendoFoto(false) }
	}
	// Sesiones abiertas antes de que existiera "Cómo Se Ve Mi Nombre": traer el nombre elegido una vez.
	useEffect(() => {
		if (!authenticated || esSoloAlumno || !userProfile?.id || userProfile.nombre_mostrar !== undefined) return
		AuthService.miNombre().then((r: any) => dispatch(setUserProfile({ ...userProfile, nombre_mostrar: r.data.actual || null }))).catch(() => {})
	}, [authenticated, esSoloAlumno, userProfile?.id])
	const [selectedUserProfile, setSelectedUserProfile] = useState<any>(null)
	const [editableUserProfile, setEditableUserProfile] = useState<any>(null)
	const [saveSuccess, setSaveSuccess] = useState<boolean>(false)

	let formRef = useRef<HTMLFormElement>(null)

	const fetchPaymentMethods = async () => {
		try {
			const response = await http.paymentMethodService.getPaymentMethodsByCountry(currentCampus.countryId);
			dispatch(setPaymentMethods(response.data));
		} catch (err: any) {
			console.error(err);
		}
	}

	const handleCampusChange = (campus: any) => {
		dispatch(setCurrentUserCampus(campus.refIndex));
		dispatch(setCurrentUserCampusId(campus.id));
		const campusId = campus.id;
		dispatch(setCurrentCampusId(campusId));
		const newCampus = campuses.find((campus: any) => campus.id === campusId);
		//Sin catálogo todavía no se pisa el plantel con un vacío: el efecto de abajo lo pone en cuanto llega.
		if (newCampus) {
			dispatch(setCurrentCampus(newCampus));
		}
	}

	useEffect(() => {
		if (currentCampus && userData && userData.token) {
			fetchPaymentMethods();
		}
	}, [currentCampusId]);

	/*
		Catálogo de planteles sin pasar por la pantalla de entrada (2026-10-21). Solo se pedía al iniciar sesión, y el puente
		de app.washingtonacademy.mx a wapp.washingtonacademy.com se lleva la sesión pero no el catálogo: quien llegó así y
		cambió de plantel en la barra se quedaba sin plantel de sesión y Finanzas tronaba ("reading 'id'").
	*/
	useEffect(() => {
		if (!userData || !userData.token || esSoloAlumno) {
			return
		}
		if (Array.isArray(campuses) && campuses.length > 0) {
			return
		}
		let vivo = true
		http.campusService.getCampuses()
			.then((respuesta: any) => {
				if (vivo && Array.isArray(respuesta?.data) && respuesta.data.length > 0) {
					dispatch(setCampuses(respuesta.data))
				}
			})
			.catch((err: any) => console.error(err))
		return () => { vivo = false }
	}, [userData, esSoloAlumno, campuses])

	/*
		UN SOLO PLANTEL ACTUAL.

		WAPP llevaba dos: el de la barra de arriba (currentUserCampus, el que la
		persona ve y cambia) y el de sessionState, que se guarda en el navegador.
		Casi todas las pantallas de dinero —Pagos, Facturas, Creditos, Estado de
		cuenta, Tablero— leen el segundo, que no se ve en ninguna parte.

		Se separaban solos por tres caminos distintos: al restaurar sesion (ya
		corregido arriba), al iniciar sesion —cada uno se fija desde una fuente
		distinta— y al abrir un enlace directo de Horarios, que mueve la barra y
		no el otro. El sintoma no parecia un problema de plantel: a una alumna de
		San Pedro Sula con 24,000.00 de saldo el estado de cuenta le salia en 0.00
		y en pesos, porque preguntaba por ella en Torreon. (Esteban, 2026-09-19)

		En vez de perseguir cada camino, el de sessionState SIGUE al de la barra,
		siempre. Nadie lo mueve a proposito por su cuenta —se reviso uno por uno—,
		asi que la barra manda y esto no le quita el control a nadie.

		No entra en bucle: al terminar los dos coinciden y la guardia de abajo
		corta. Si el catalogo aun no llego, no hace nada y se reintenta cuando
		llegue.
	*/
	useEffect(() => {
		if (!userData || !userData.token) {
			return
		}

		if (!Array.isArray(campuses) || campuses.length < 1) {
			return
		}

		const plantelDeLaBarra: number | null = campusRef?.[currentUserCampus]?.id ?? null

		if (plantelDeLaBarra == null) {
			return
		}

		if (currentCampus?.id === plantelDeLaBarra && currentCampusId === plantelDeLaBarra) {
			return
		}

		const plantel: any = campuses.find((registro: any) => registro.id === plantelDeLaBarra)

		if (plantel == null) {
			return
		}

		dispatch(setCurrentCampusId(plantelDeLaBarra))
		dispatch(setCurrentCampus(plantel))
	}, [currentUserCampus, campusRef, campuses, currentCampus, currentCampusId, userData])

	/*
		El plantel de la barra se guarda en el navegador cada vez que cambia. Antes solo lo guardaban
		unas pantallas viejas (Calendario, Salones), así que cambiar de plantel en la barra y recargar
		regresaba al último que esas guardaron: "estaba en TGU, refresqué y me mandó a SPS"
		(Esteban, 2026-09-24). Solo se guarda un plantel que la persona tiene; vacío no borra nada.
	*/
	useEffect(() => {
		if (!currentUserCampus || !campusRef?.[currentUserCampus]) {
			return
		}

		try {
			localStorage.setItem("currentCampus", currentUserCampus)
		}
		catch (e) {
			//Sin almacenamiento (modo privado): no pasa nada, solo no se recuerda.
		}
	}, [currentUserCampus, campusRef])

	const logout = async () => {
		// Este aparato deja de recibir avisos de esta persona (antes de cerrar la sesión en el servidor; máximo 1.5 s).
		await olvidarEsteAparato()
		dispatch(handleLogout());
		localStorage.removeItem("persist:root");
		AuthService
			.logout(sessionToken)
			.then
			(
				() => {
					let menu = baseMenu
					let menuMap = []

					localStorage.clear()
					dispatch(setUserProfile(null))
					dispatch(setCurrentUserCampus(null))
					dispatch(setCurrentUserCampusId(null))
					dispatch(setCampusRef(null))
					dispatch(setSessionToken(null))
					dispatch(setAuthenticated(false))
					dispatch(setUser(null));

					menu?.forEach
						(
							(element: any, index: number) => {
								element.sections.forEach
									(
										(item: any, subIndex: number) => {
											menuMap[item.route] = element.block.group
										}
									)
							}
						)

					dispatch(setUserMenu(baseMenu))
					dispatch(setMenuRef(null))
					dispatch(setNavigation(baseNavigation))
					navigate("/access")
					window.location.reload()
				},
				(error: any) => {
					//Si el servidor ya no reconoce la sesión (401), la guardia de sesión se encarga.
					//Cualquier otro fallo (red caída) igual cierra en este equipo: el token se borra
					//y se recarga limpio. Antes se quedaba el token muerto guardado y la persona
					//rebotaba entre el error y el login (2026-09-29).
					if (error?.response?.status !== 401) {
						borrarSesionLocal()
						window.location.replace("/access")
					}
				}
			)
			.finally(() => dispatch(disableIdleLockSwitch()))
	}

	const fetchRoleData = async () => {
		if (!currentRole || !userProfile) {
			return null;
		}
		try {
			dispatch(enableIdleLockSwitch());
			const response = await http.roleService.updateActiveRole(userProfile.id, currentRole.id);
			dispatch(setPermissions(response.data.permissions));
			return response.data;
		} catch (err: any) {
			console.error("Error al obtener datos del rol:", err);
			dispatch(
				displayNotice({
					heading: <h3 style={{ color: "var(--wa-rojo-error)", display: "inline-block" }}>Error</h3>,
					message: "No se pudieron cargar los permisos del rol actual",
					cornerClose: false
				})
			);
		} finally {
			dispatch(disableIdleLockSwitch());
		}
	};

	useEffect(() => {
		const loadRoleData = async () => {
			await fetchRoleData();

			const roleJustChanged = localStorage.getItem("roleJustChanged");
			if (roleJustChanged === "true") {
				localStorage.removeItem("roleJustChanged");
				window.location.reload();
			}
		};

		loadRoleData();
	}, [currentRole, userProfile]);

	const onLoad = async () => {
		let menuMap: any = {}
		let assignedNavigation: any
		let menu: any

		dispatch(enableIdleLockSwitch())

		try {
			const accessToken: any = localStorage.getItem("accessToken")

			if (accessToken?.trim()) {
				dispatch(setSessionToken(accessToken))

				const result: any = await AuthService.getInitData()
				let user: any = result.data.user
				anotarDuenoDelToken(user && user.id)
				marcarCambioDeClave(user)
				let campuses: any = result.data.campuses
				let campusIndex: any = {}
				const currentRole: string | null = localStorage.getItem("currentRole")
				user.currentCampus = localStorage.getItem("currentCampus")

				if (currentRole == null) {
					if (user.roles.length > 0) {
						user.currentRole = user.initialRole.code
					}
					else {
						if (user.student) {
							user.currentRole = "student"
						}
					}
				}
				else {
					if ((currentRole == "student" && user.student) || (user.roles.length > 0 && user.roleMap[currentRole])) {
						user.currentRole = currentRole
					}
					else {
						localStorage.removeItem("currentRole")
					}
				}

				if (user.currentRole) {
					dispatch(setCurrentUserRole(user.currentRole))
					localStorage.setItem("currentRole", user.currentRole)
				}

				let refIndex: string

				if (user.currentRole == "student") {
					menu = studentMenu
					assignedNavigation = studentNavigation

					user.student.campuses.map
						(
							(campus: any) => {
								refIndex = "C_" + campus.id
								campusIndex[refIndex] = { ...campus, refIndex: refIndex }

								return
							}
						)

					user.student.campusRef = campusIndex
				}
				else {
					if (user.roleMap[user.currentRole].campuses && user.roleMap[user.currentRole].campuses.length > 0) {
						dispatch(setAllowedCampuses(user.roleMap[user.currentRole].campuses));
						user.roleMap[user.currentRole].campuses.map
							(
								(campus: any) => {
									refIndex = "C_" + campus.id
									campusIndex[refIndex] = { ...campus, refIndex: refIndex }

									return
								}
							)
					}

					if (user.roleMap[user.currentRole].campuses.length > 0) {
						if (user.currentCampus == null || campusIndex[user.currentCampus] == null) {
							user.currentCampus = "C_" + user.roleMap[user.currentRole].campuses[0].id
							dispatch(setCurrentCampusId(user.roleMap[user.currentRole].campuses[0].id));
						}
					}
					else {
						if (user.currentCampus) {
							user.currentCampus = null
						}
					}

					if (user.currentCampus) {
						localStorage.setItem("currentCampus", user.currentCampus)
						/*
							Aqui iba campuses[0].id, o sea SIEMPRE el primer plantel del rol,
							aunque la persona tuviera otro escogido. De ahi salia que la barra
							dijera "San Pedro Sula" y las pantallas de dinero preguntaran por
							Torreon. Se fija el plantel que de verdad esta escogido.
							(Esteban, 2026-09-19)
						*/
						dispatch(setCurrentCampusId(campusIndex[user.currentCampus].id));
					}
					else {
						if (localStorage.getItem("currentCampus")) {
							localStorage.removeItem("currentCampus")
						}
					}

					const [complementaryMenu, complementaryNavigation] = generateSectionMap(user)
					menu = [...baseMenu, ...complementaryMenu]
					assignedNavigation = [...baseNavigation, ...complementaryNavigation]
				}

				dispatch(setCurrentUserCampusId(user.currentCampus ? campusIndex[user.currentCampus].id : null))
				dispatch(setCampusRef({ ...campusIndex }))
				dispatch(setCurrentUserCampus(user.currentCampus))
				basicSetup(result.data, dispatch)
			}
			else {
				menu = baseMenu
				assignedNavigation = baseNavigation
			}
		}
		catch (error) {
			menu = baseMenu
			assignedNavigation = baseNavigation

			console.log(error)
			localStorage.clear()
		}
		finally {
			loadApp(true)
			dispatch(disableIdleLockSwitch())

			menu?.forEach
				(
					(element: any, index: number) => {
						element.sections.forEach
							(
								(item: any, subIndex: number) => {
									menuMap[item.route] = element.block.group
								}
							)
					}
				)

			dispatch(setUserMenu(menu))
			dispatch(setMenuRef(menuMap))
			dispatch(setNavigation(assignedNavigation))
		}
	}

	useEffect(() => { onLoad() }, [])

	/*
		Enlace directo que llegó sin sesión (Cliq → /auditQuestions?caso=…&plantel=…): ya con sesión, se abre en cuanto el menú
		de la persona tiene esa ruta. Si su menú ya cargó y no la tiene (sin permiso), se descarta y se queda en la portada.
	*/
	/*
		Enlace con «rol=» (Cliq de Preguntas de Auditoría): si la persona tiene ese rol y está en otro, se guarda a dónde iba y se
		cambia de rol por el mismo camino que el selector de roles (recarga); al volver, lo de abajo abre el destino ya en ese rol.
	*/
	const sinRol = (search: string): string => {
		const q = new URLSearchParams(search.replace(/^\?/, ""))
		q.delete("rol")
		const resto = q.toString()
		return resto ? "?" + resto : ""
	}
	const esperaDestino = useRef<any>(null)
	const rolDelEnlace = (ruta: string): any => {
		const id = new URLSearchParams(ruta.split("?")[1] || "").get("rol")
		if (!id || !Array.isArray(roles)) return null
		return roles.find((r: any) => String(r.id) === id) || null
	}
	useEffect(() => {
		if (!authenticated || !Array.isArray(navigation) || navigation.length < 1) {
			return
		}
		const aqui = rolDelEnlace(ubicacion.search)
		if (aqui && rolActivo() !== aqui.code) {
			guardarDestino()
			changeRole(aqui.code)
			return
		}
		if (Array.isArray(roles) && roles.length > 0 && new URLSearchParams(ubicacion.search).has("rol")) {
			// Ya en ese rol (o no lo tiene): el «rol=» se consumió y se quita de la dirección. Si se queda, elegir otro rol en el selector
			// lo regresaba a este (el enlace lo volvía a pedir).
			// Con la dirección de AHORA (no la de este render): si useEnlaceDirecto ya consumió caso/plantel, no se vuelven a poner.
			navigate(window.location.pathname + sinRol(window.location.search), { replace: true })
			return
		}
		const destino = verDestino()
		if (!destino) {
			return
		}
		const pideRol = new URLSearchParams(destino.split("?")[1] || "").get("rol")
		if (pideRol && (!Array.isArray(roles) || roles.length < 1)) {
			return   // los roles todavía no llegan: sin esto el destino se tomaba (y se perdía) antes de poder cambiar de rol
		}
		const rol = rolDelEnlace(destino)
		if (rol && rolActivo() !== rol.code) {
			changeRole(rol.code)   // el destino se queda guardado: se abre después de la recarga, ya en ese rol
			return
		}
		const ruta = destino.split("?")[0].replace(/^\//, "")
		if (navigation.some((n: any) => n.path === ruta)) {
			tomarDestino()
			clearTimeout(esperaDestino.current)
			// Después de los efectos de esta misma pasada: el <Navigate to="/"> de la pantalla de acceso corre antes y, si no, gana.
			const sinElRol = destino.split("?")[0] + sinRol(destino.split("?")[1] || "")
			setTimeout(() => navigate(sinElRol, { replace: true }), 0)
			return
		}
		// El menú de este rol todavía no trae esa pantalla (acaba de cambiar de rol y el menú se está cargando): el destino se queda.
		// Si a los 15 segundos sigue sin estar, la persona no tiene esa pantalla en este rol y se descarta (se queda en la portada).
		clearTimeout(esperaDestino.current)
		esperaDestino.current = setTimeout(() => { if (verDestino() === destino) tomarDestino() }, 15000)
	}, [authenticated, navigation, ubicacion.pathname, ubicacion.search, roles, currentRole])

	const saveUserProfile = async () => {
		if (formRef && formRef.current) {
			if (!formRef.current.checkValidity()) {
				setUnfilledFields(true)
				formRef.current.reportValidity()

				setTimeout
					(
						() => {
							setUnfilledFields(false)
						},
						3000
					)
			}
			else {
				if
					(
					(
						basicInfo.countryRef["C_" + editableUserProfile.country_id].states.length > 0 &&
						basicInfo.countryRef["C_" + editableUserProfile.country_id].stateRef["S_" + editableUserProfile.state_id].cities.length > 0
					)
					&&
					(editableUserProfile.city == null || editableUserProfile.city.id == null)
				) {
					setUnfilledFields(true)
					setNoCityProvided(true)

					setTimeout
						(
							() => {
								setUnfilledFields(false)
								setNoCityProvided(false)
							},
							3000
						)
				}
				else {
					if (sessionToken) {
						dispatch(enableIdleLockSwitch());

						try {
							const result = await AuthService.saveCurrentUser(editableUserProfile)
							setUIStatus(UIState.LOCKED)

							if (result.status == 200 || result.status == 204) {
								setSaveSuccess(true)
								setUIStatus(UIState.SUCCESS)

								if (saveError != null) {
									setSaveError(null)
								}

								setTimeout
									(
										() => {
											dispatch
												(setUserProfile({ ...editableUserProfile, image: result.data.image }))
											setSelectedUserProfile(null)
											setEditableUserProfile(null)
											setSaveSuccess(false)
											setUIStatus(UIState.NORMAL)
										},
										tunning.MODAL_DISMISS_DELAY
									)
							}
							else {
								setSaveError
									(
										result.status == 409
											?
											"Hay conflictos en la información proporcionada (correo electrónico, código de identificación). " +
											"Revise que los valores sean únicos en comparación con los registros existentes (alumnos, empleados)"
											:
											"La información no pudo ser guardada"
									)
								setUIStatus(UIState.ERROR)
							}
						}
						catch (error: any) {
							console.log(error)
							setSaveError
								(
									error.response.status != 409 ? "La información no pudo ser guardada" : "Hay conflictos en la información proporcionada " +
										"(" + (error.response.data.message == "duplicate_email_info" ? "correo electrónico" : "código de identificación") + "). " +
										"Revise que los valores sean únicos en comparación con los registros existentes (alumnos, empleados)"
								)
							setUIStatus(UIState.ERROR)
						}
						finally {
							dispatch(disableIdleLockSwitch())
						}
					}
				}
			}
		}
	}

	const themeToggle: boolean = useSelector((state: RootState) => state.themeToggle.value)

	const commonNotice:
		{ heading: ReactNode | null; message: string | null; procedure?: any; optOutProcedure?: any; cornerClose?: boolean } =
		useSelector((state: RootState) => state.commonNotice)

	const icons =
		[
			regular("moon"),
			solid("sun")
		];

	const modeSettings =
		[
			{
				id: "light",
				name: "Light",
				background: "lightBackground",
				class: "theme-mode-light"
			},
			{
				id: "dark",
				name: "Dark",
				background: "dark-background",
				class: "theme-mode-dark"
			}
		];

	const themeSetting = () => {
		const toggle = !themeToggle
		const mode = modeSettings[+!themeToggle]

		localStorage.setItem("themeMode", mode.class)
		dispatch(toggleTheme())
	};

	/*
		El tema tambien se marca en <html>. Hasta ahora la clase vivia en un div de
		adentro de #root, y todo lo que React saca por un portal (los modales, los
		globos de react-tiny-popover, los avisos) cuelga de <body>: quedaba FUERA
		de esa clase y resolvia las variables --wa-* con los valores CLAROS. El
		resultado era una ventana blanca encima de la app oscura. Desde <html>
		alcanza a todo, incluida la franja de rebote del navegador.
		(Esteban, 2026-09-20)
	*/
	useEffect
	(
		() =>
		{
			const raiz = document.documentElement

			raiz.classList.remove("theme-mode-light", "theme-mode-dark")
			raiz.classList.add(modeSettings[+themeToggle].class)
		},
		[themeToggle]
	)

	const toggleRoleListDisplay = () => {
		roleListDisplay(!roleListShown)
	}

	/*
		El rol con el que de verdad se armó el menú es el de localStorage (onLoad); el de sessionState puede quedarse con el del
		inicio de sesión. Un enlace con «rol=» que se comparaba contra ese no cambiaba de rol y la persona caía en la portada.
	*/
	const rolActivo = (): string | undefined => localStorage.getItem("currentRole") || currentRole?.code
	const changeRole = (roleCode: string) => {
		if (rolActivo() === roleCode && currentRole?.code === roleCode) {
			return
		}
		localStorage.setItem("currentRole", roleCode);
		if (currentRole?.code === roleCode) {
			window.location.reload();   // la sesión ya decía ese rol pero el menú es de otro: se recarga con el rol bueno
			return
		}
		localStorage.setItem("roleJustChanged", "true");
		dispatch(setCurrentRole(roles.find((r: any) => r.code === roleCode)));
	}

	const showUserProfile = (recordData: any) => {
		let links: any = isNotEmpty(recordData.links) ? JSON.parse(recordData.links) : {}

		Object.keys(links).map((key: string) => links[key] = links[key] || "")
		setUIStatus(UIState.NORMAL)
		setSaveError(null)
		setSelectedUserProfile
			({
				// Sin ciudad guardada (cuentas nuevas de asesoras, 2026-10-10) "Ver perfil" tronaba y no se podía ni cambiar la foto.
				...links, ...recordData, city: recordData.city ? { ...recordData.city, label: recordData.city.name } : null,
				zipcode: recordData.zipcode || "",
				imagePreview: recordData.image,
			})
	}

	const MenuDivRef: any = useRef<HTMLDivElement>(null)
	const menuToggleRef: any = useRef<HTMLButtonElement>(null)

	useClickOutsideRef(MenuDivRef, menuToggleRef)

	const setActiveMenu = () => MenuDivRef?.current?.classList?.add("active")
	const closeMenu = () => MenuDivRef?.current?.classList?.remove("active")

	// Menú fijo en PC (Esteban, 2026-10-09): quien quiera deja el menú siempre abierto y la página se recorre a la derecha.
	// Solo aplica desde 1200 px (ver app.css); se recuerda en este navegador.
	const [menuFijo, setMenuFijo] = useState<boolean>(() => { try { return localStorage.getItem("wapp.menuFijo") === "1" } catch (e) { return false } })
	useEffect(() => {
		document.documentElement.classList.toggle("wapp-menu-fijo", menuFijo)
		try { localStorage.setItem("wapp.menuFijo", menuFijo ? "1" : "0") } catch (e) { /* sin almacenamiento */ }
	}, [menuFijo])
	const alternarMenuFijo = () => { if (menuFijo) closeMenu(); setMenuFijo(!menuFijo) }

	return (!appLoaded || userMenu == null || navigation == null) ? <></> : <>
		<StagingBanner />
		{/* El tema pinta desde aqui: todo lo de adentro hereda las variables --wa-*.
		    Antes el fondo venia de --second-bg, que en oscuro era un gris plano; ahora
		    es el papel del tema, que en oscuro es negro calido. (Esteban, 2026-09-20) */}
		<div className={themes[+themeToggle]} style={{ color: "var(--wa-tinta)" }}><div
			style={{ background: "var(--wa-papel-2)", minHeight: "100vh" }}
		>
			{
				!authenticated ? "" : <div>
					<div className="topNav" style={{ display: (location == "access" ? "none" : "") }}>
						{/* La marca del producto va centrada en la barra. Va absoluta para que
						    no empuje ni el nombre del plantel ni el bloque del usuario, y
						    lleva al Panel, igual que al entrar. Mientras la app esta ocupada
						    se queda sin enlace, como el resto de la navegacion. */}
						<div className="topNavBrand">
							{
								idleLocked
									?
									<img src={wappWordmark} alt="WAPP" />
									:
									<Link to="/" title="Ir al Panel" aria-label="Ir al Panel">
										<img src={wappWordmark} alt="WAPP" />
									</Link>
							}
						</div>
						<div className="topnavRightItem" style={{ flexGrow: 1 }}>
							<div style={{ display: "flex", justifyContent: "left", alignItems: "center", padding: "4px 10px 4px 15px" }}>
								<button ref={menuToggleRef} className="dropdownToggle" onClick={setActiveMenu}
									type="button" style={{ paddingTop: "0px" }}
								>
									<FontAwesomeIcon icon={solid("bars")} style={{ color: "var(--wa-acento)" }} size="2x" />
								</button>
								{
									currentUserCampus == null ? "" :
										(
											Object.keys(campusRef).length < 2
												?
												<>
													<Popover isOpen={campusesListShown} onClickOutside={() => setCampusesListShown(false)}
														positions={["bottom"]} content=
														{<div style={{ padding: "10px 5px", minWidth: "250px", background: "var(--main-bg)", left: "43px" }}>
															<div style={{ padding: "10px 5px" }}>
																<div className="d-sm-table-cell d-sm-none d-md-none d-lg-none d-xl-none">
																	<FontAwesomeIcon
																		icon={solid("check-circle")}
																		style={{ marginLeft: "7px" }}
																	/>
																	<span style={{ paddingLeft: "7px" }}>
																		{campusRef[currentUserCampus].name}
																	</span>
																</div>
															</div>
														</div>}
													>{/* Al alumno el selector de plantel no le sirve: solo el nombre (QA 2026-10-21). */}<button style={{ color: "var(--wa-acento)", display: esSoloAlumno ? "none" : "inline-flex", paddingTop: "0px" }} disabled={idleLocked}
														className="btn d-sm-table-cell d-sm-none d-md-none d-lg-none d-xl-none" type="button"
														onClick={() => setCampusesListShown(!campusesListShown)}
													>
															<FontAwesomeIcon icon={solid("school-flag")}
																style={{ marginLeft: "7px" }}
															/>
															<FontAwesomeIcon icon={solid("caret-down")}
																style={{ marginLeft: "7px" }}
															/>
														</button></Popover>
													{/* El nombre no se recorta a la mitad ("Washington Academy Mo" no
													    dice nada): se abrevia. Completo cuando cabe, "WA Monterrey"
													    cuando aprieta, y las siglas del plantel en telefono.
													    (Esteban, 2026-09-16) */}
													<span className="topNavPlantel">
														<span className="plantelLargo">{campusRef[currentUserCampus].name}</span>
														<span className="plantelMedio">{plantelMedio(campusRef[currentUserCampus].name)}</span>
														<span className="plantelSiglas">{plantelSiglas(campusRef[currentUserCampus].name)}</span>
													</span>
												</>
												:
												<Popover onClickOutside={() => setCampusesListShown(false)} isOpen={campusesListShown}
													positions={["bottom"]} content=
													{<div style={{ padding: "10px 5px", minWidth: "250px", background: "var(--main-bg)", left: "43px" }}>
														<div className="d-sm-table-cell d-sm-none d-md-none d-lg-none d-xl-none"
															style={{ paddingBottom: "10px" }}
														>
															<FontAwesomeIcon icon={solid("check-circle")} style={{ marginLeft: "7px" }} />
															<span style={{ paddingLeft: "7px" }}>
																{campusRef[currentUserCampus].name}
															</span>
														</div>
														<fieldset style={{ padding: "5px 10px 0px" }}>
															<legend style={{ position: "relative", bottom: "10px" }}><label
																style={{ background: "var(--main-bg)" }}
															>
																Seleccione otro plantel
															</label></legend>
															{
																Object.values(campusRef).map
																	(
																		(campus: any) => {
																			if (currentUserCampus != campus.refIndex) {
																				return <button style={{ width: "100%", textAlign: "left" }}
																					onClick={() => handleCampusChange(campus)}
																					className="btn btn-default" key={"CA_" + campus.id}
																					disabled={idleLocked}
																				>
																					{campus.name}
																				</button>
																			}
																		}
																	)
															}
														</fieldset>
													</div>}
												><button onClick={() => setCampusesListShown(!campusesListShown)} disabled={idleLocked}
													type="button" className="btn" style={{ padding: "0px 8px", marginLeft: "8px" }}
												><span className="topNavPlantelCaja">
															{/* Antes en telefono salia un iconito de bandera que no decia de
															    que plantel se trataba. Ahora sale el nombre abreviado.

															    Esto colgaba de un display:table-row con un top:3px encima: el
															    nombre y la flecha quedaban en celdas distintas alineadas por
															    linea base, y el texto salia mas arriba que el resto de la
															    barra. Ahora es una fila flex centrada, que alinea igual con
															    cualquier texto y a cualquier ancho. (Esteban, 2026-09-16) */}
															<span className="topNavPlantel">
																<span className="plantelLargo">{campusRef[currentUserCampus].name}</span>
																<span className="plantelMedio">{plantelMedio(campusRef[currentUserCampus].name)}</span>
																<span className="plantelSiglas">{plantelSiglas(campusRef[currentUserCampus].name)}</span>
															</span>
															<FontAwesomeIcon icon={solid("caret-down")} />
														</span></button></Popover>
										)
								}
								<div ref={MenuDivRef} className="themeMenu">
									{/* El lockup va entero, de una sola pieza: el kit de marca no se
									    parte en aguila + letrero por separado. */}
									<div className="menuLogo" style={{ padding: "25px 30px 25px 20px", height: "113px", display: "flex", alignItems: "center", position: "relative" }}>
										<img src={themeToggle ? logoMenuBlanco : logoMenu} alt="Washington Academy"
											style={{ width: "100%", maxHeight: "63px", objectFit: "contain" }} />
										<button type="button" className={"menuFijar" + (menuFijo ? " on" : "")} onClick={alternarMenuFijo}
											title={menuFijo ? "Ocultar el menú" : "Dejar el menú siempre abierto"} aria-pressed={menuFijo}
											aria-label={menuFijo ? "Ocultar el menú" : "Dejar el menú siempre abierto"}
										>
											<WappIcono n="sidebar" />
										</button>
									</div>
									<div style={{ height: "calc(100vh - 175px)", overflowY: "auto" }}><table id="sideMenu"
										style={{ width: "100%" }}
									>{
											//Honduras: sin Catálogo ni Inventario viejos (2026-10-31).
											menuDelPlantel(userMenu, currentCampusId).map
												(
													(path: any, index: number) => <Accordion currentRoute={location} block={path.block}
														content={path.sections} key={index}
													/>
												)
										}</table></div>
									<table style={{ position: "absolute", bottom: "0px", width: "100%" }}><tbody><tr>
										{/* Era un circulito oscuro de 30px sin etiqueta al fondo del menu: nadie lo
										    encontraba. Ahora dice lo que hace. (Esteban, 2026-09-20) */}
										<td style={{ background: "var(--wa-superficie)", borderTop: "1.5px solid var(--wa-filo)", padding: "0px 8px 0px 18px", whiteSpace: "nowrap" }}>
											<button
												style={{
													background: "none", border: "0px", display: "inline-flex", alignItems: "center",
													gap: "10px", height: "62px", padding: "0px", color: "var(--wa-apagado)", cursor: "pointer"
												}}
												onClick={themeSetting}
												type="button"
												title={themeToggle ? "Cambiar a modo claro" : "Cambiar a modo oscuro"}
											>
												<FontAwesomeIcon icon={icons[+themeToggle]} size="lg" />
												<span style={{ fontSize: "14px", fontWeight: 500 }}>
													{themeToggle ? "Modo claro" : "Modo oscuro"}
												</span>
											</button>
										</td>
										<td style={{ background: "var(--wa-superficie)", borderTop: "1.5px solid var(--wa-filo)", textAlign: "center", width: "100%" }}><button
											style={{ height: "62px", color: "var(--wa-apagado)" }} className="themeMenuClose" type="button"
											onClick={closeMenu}
										>
											<FontAwesomeIcon size="xs" style={{ position: "relative", bottom: "5px" }}
												icon={solid("chevron-left")}
											/>
										</button></td>
									</tr></tbody></table>
								</div>
							</div>
						</div>
						<div className="topNavRight">
							<ContadoresBarra />
							<CorreoNoLeidos />
							<div>
								<p className="topnavRightItem" style={{ padding: "0px", margin: "0px", color: "var(--wa-acento-texto)" }}>
									<b>{esSoloAlumno ? userProfile.first_name : nombrePersonal(userProfile)}</b>
								</p>
							</div>
							<div className="topnavRightItem" style={{ padding: "0px 15px 0px 0px" }}>
							</div>
							<div className="topnavRightItem" style={{ display: "flex", alignItems: "center" }}><Popover positions={["bottom"]}
								onClickOutside={() => setUserProfileOptionsShown(false)} isOpen={userProfileOptionsShown}
								reposition={false} content=
								{<div className="card perfilMenuCard" style=
									{{ background: "var(--main-bg)", padding: "5px 5px 0px", position: "absolute", right: "0px", width: "250px", maxHeight: "calc(100vh - 64px)", overflowY: "auto" }}
								>
									<div className="dropdownFooter">
										Usuario
									</div>
									<div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
										<div style={{ position: "relative" }}>
											<img style={{ width: "160px", height: "160px", borderRadius: "50%", objectFit: "cover", opacity: subiendoFoto ? 0.5 : 1 }} alt="user photo"
												src={userProfile.image || avatarPorDefecto(themeToggle)}
											/>
											<label className="fotoCambiar" title="Cambiar foto" aria-label="Cambiar foto">
												<FontAwesomeIcon icon={solid("camera")} />
												<input type="file" accept="image/jpeg,image/png,image/webp" hidden disabled={subiendoFoto} onChange={cambiarFoto} />
											</label>
										</div>
										{fotoAviso ? <div className="fotoAviso" role="status">{fotoAviso}</div> : null}
										{
											esSoloAlumno ? <b style={{ fontSize: "12px", marginTop: "15px" }}>
												{userProfile.first_name}
												&nbsp;
												{userProfile.last_name}
											</b> : <MiNombre nombre={nombrePersonal(userProfile)} disabled={idleLocked}
												onCambio={(nombre) => dispatch(setUserProfile({ ...userProfile, nombre_mostrar: nombre }))}
											/>
										}
										{esSoloAlumno ? null : <>
										<div style={{ fontSize: "10px", color: "var(--txt-secondary-color)", width: "75%", textAlign: "center" }}>
											ID DE USUARIO
										</div>
										<b style={{ fontSize: "12px" }}>
											{userProfile.id}
										</b>
										</>}
									</div>
									{/* Rol: el nombre entero (la pastilla cortaba "Dirección y Sub-Dirección de Ventas", Esteban 2026-10-29). */}
									{
										userProfile.currentRole == null ? "" : <div className="perfilRol">
											<small>Rol</small>
											<b>{
												(userProfile.currentRole == "student" && "Estudiante")
												|| userProfile.roleMap[userProfile.currentRole]?.name
											}</b>
										</div>
									}
									<div className="perfilMenuLista">
										{
											(
												userProfile.currentRole == null ||
												userProfile.roles.length < 1 ||
												(userProfile.student == null && userProfile.roles.length < 2)
											)
												? null : <button className="btn perfilMenuItem" disabled={idleLocked} type="button" onClick={toggleRoleListDisplay}>
													<span className="perfilMenuIco"><FontAwesomeIcon icon={solid("arrows-rotate")} /></span>
													<span>Cambiar Rol</span>
												</button>
										}
										{/* Alumno: "Mi Perfil" del portal. La ficha de "Ver Perfil" necesita catálogos del personal y tronaba (QA 2026-10-21). */}
										{
											esSoloAlumno ? <button className="btn perfilMenuItem" disabled={idleLocked} type="button"
												onClick={() => { setUserProfileOptionsShown(false); navigate("/miPerfil") }}
											>
												<span className="perfilMenuIco"><FontAwesomeIcon icon={regular("user")} /></span>
												<span>Mi Perfil</span>
											</button> :
											userProfile.roleMap["superAdmin"] ? "" : <button className="btn perfilMenuItem" disabled={idleLocked} type="button" onClick=
												{
													() => {
														setUserProfileOptionsShown(false)
														showUserProfile
															(
																userProfile.currentRole != "student"
																	? { ...userProfile, ...userProfile.employee }
																	: { ...userProfile, ...userProfile.student }
															)
													}
												}
											>
												<span className="perfilMenuIco"><FontAwesomeIcon icon={regular("user")} /></span>
												<span>Ver Perfil</span>
											</button>
										}
										<button className="btn perfilMenuItem" disabled={idleLocked} type="button"
											onClick={() => { setUserProfileOptionsShown(false); navigate("/app") }}
										>
											<span className="perfilMenuIco"><FontAwesomeIcon icon={solid("mobile-screen-button")} /></span>
											<span>WAPP En Tu Celular</span>
										</button>
										<button className="btn perfilMenuItem" disabled={idleLocked} type="button"
											onClick={() => { setUserProfileOptionsShown(false); navigate("/avisos?vista=preferencias") }}
										>
											<span className="perfilMenuIco"><FontAwesomeIcon icon={regular("bell")} /></span>
											<span>Mis Avisos</span>
										</button>
										<button className="btn perfilMenuItem perfilMenuSalir" onClick={logout} disabled={idleLocked} type="button">
											<span className="perfilMenuIco"><FontAwesomeIcon icon={solid("arrow-right-from-bracket")} /></span>
											<span>Cerrar Sesión</span>
										</button>
									</div>
								</div>}
							><div className="topNavRightUser"><button className="topNavRightUserImage" disabled={idleLocked}
								type="button" onClick={() => setUserProfileOptionsShown(!userProfileOptionsShown)}
							>
								<img src={userProfile.image || avatarPorDefecto(themeToggle)} style={{ height: "100%" }} alt="user picture" />
							</button></div></Popover></div>
						</div>
					</div>
					{
						!idleLocked ? "" : <div className="loadingBar"><div style={{ padding: "5px 25px" }}>
							<div className="loader0" style={{ borderRadius: "15px" }} />
						</div></div>
					}
				</div>
			}
			<div className="layoutContentMain" style={{ height: "calc(100vh - 59px)", overflowY: "auto", overflowX: "hidden", width: "100vw" }}><Routes><Route
				key={"access"} path={"/access"} element={<Access />}
			/>{
					navigation && navigation.map
						(
							({ path, element: Component }: any) => {
								return <Route key={path} path={"/" + path} element={<PrivateRoute authenticated={authenticated}>
									<Component />
								</PrivateRoute>}
								/>
							}
						)
				}<Route key="app" path="/app" element={<PrivateRoute authenticated={authenticated}><AppMovilView /></PrivateRoute>} />
				<Route key="avisos" path="/avisos" element={<PrivateRoute authenticated={authenticated}><AvisosView /></PrivateRoute>} />
				<Route key="*" path="/*" element={authenticated ? <IrAlInicio authenticated={authenticated} /> : <IrAlLogin />} /></Routes></div>
		</div></div>
		<VisorDeArchivos />
		<CambioDeClaveObligatorio />
		<TelefonoGlobal />
		{/* Un alumno no tiene WappTeam ni llamadas del equipo: su token no puede tocar /admin y cada sondeo sería un 403. */}
		{authenticated && !esSoloAlumno ? <LlamadasEquipo /> : null}
		{authenticated && !esSoloAlumno ? <WappTeamDock /> : null}
		<AppMovilGlobal authenticated={authenticated} />
		{authenticated ? <AvisosEnVivo /> : null}
		{authenticated ? <FestejoMatricula /> : null}
		{
			selectedUserProfile == null ? "" : <UserPrompt promptCloseFn={() => setSelectedUserProfile(null)} UIStatus={UIStatus}
				statusIndex={userProfile.currentRole != "student" ? "employeeStatusRef" : "studentStatusRef"} profileView={true}
				processingError={saveError} selectedUser={selectedUserProfile} allowedUpdate={true} saveSuccess={saveSuccess}
				uneditFn={() => setEditableUserProfile(null)} saveDataFn={saveUserProfile} title="Perfil de usuario"
				employeeView={userProfile.currentRole != "student"} icon={<FontAwesomeIcon icon={solid("id-badge")} />}
				unfilledFields={unfilledFields} dataEditFn=
				{
					() => {
						setEditableUserProfile
							({
								...selectedUserProfile, state_id: selectedUserProfile.city.state_id,
								country_id: selectedUserProfile.city.state.country_id,
								city://Format requirement of the select component
								{
									id: selectedUserProfile.city.id,
									label: selectedUserProfile.city.name
								}
							})
					}
				}
			/>
		}
		{
			!roleListShown ? "" : <Modal appElement={document.getElementById("root") as HTMLElement} className={themes[+themeToggle]}
				style=
				{{
					overlay: { zIndex: 100 },
					content: { height: "min-content", background: "var(--main-bg)", borderRadius: "15px" }
				}} isOpen
			>
				<div style={{ padding: "12px 15px 7px 15px" }}><div style={{ display: "table-row" }}>
					<div style={{ display: "table-cell", color: "var(--txt-color)", paddingTop: "5px", width: "100%" }}>
						Cambiar rol
					</div>
					<div style={{ display: "table-cell" }}><button onClick={toggleRoleListDisplay} type="button"
						disabled={idleLocked || saveSuccess} className="button btn btn-default" style=
						{{
							color: "var(--txt-color)",
							background: "var(--main-bg)",
							borderRadius: "50%",
							width: "40px",
							border: "1px solid var(--wa-filo-2)",
							padding: "2px 0px 0px 2px"
						}}
					>
						<FontAwesomeIcon icon={solid("times")} size="2x" />
					</button></div>
				</div></div>
				<div style={{ width: "100%", padding: "unset", maxHeight: "calc(90vh - 4em)" }}><div
					style={{ padding: "30px 30px 10px", overflowY: "auto" }}
				>
					Rol actual:
					<div className="badge rounded-pill bg-primary">{
						(userProfile.currentRole == "student" && "Estudiante")
						|| userProfile.roleMap[userProfile.currentRole].name
					}</div>
					<br />
					<br />
					{
						userProfile.student == null || userProfile.currentRole == "student" ? "" : <button type="button"
							className="btn btn-outline-dark" onClick={() => changeRole("student")} disabled={idleLocked}
							style={{ display: "table-row", width: "100%" }}
						>
							<span style={{ display: "table-cell", width: "100%" }}>
								Estudiante
							</span>
							<span style={{ display: "table-cell" }}>
								<FontAwesomeIcon icon={solid("chevron-right")} />
							</span>
						</button>
					}
					{
						Object.keys(userProfile.roleMap).filter((key: string) => key != userProfile.currentRole).map
						(
							(key : string, index : number) => <fieldset key={key}>
								<legend>
									<button className="btn btn-outline-dark" disabled={idleLocked}
									  key={"r_" + index} onClick={() => changeRole(key)} style={{ display: "table-row", width: "100%" }}
									>
										<span style={{ display: "table-cell", width: "100%" }}>
											{userProfile.roleMap[key].name}
										</span>
										<span style={{ display: "table-cell" }}>
											<FontAwesomeIcon icon={solid("chevron-right")} />
										</span>
									</button>
								</legend>
								<div>{
									userProfile.roleMap[key].campuses.map
									(
										(campus : any) => <div key={"C_" + campus.id}
										  style={{display : "inline-block", padding : "0px 5px"}}
										>
											<span className="badge" style={{background : "var(--wa-acento)"}}>{
												campus.name
											}</span>
										</div>
									)
								}</div>
							</fieldset>
						)
					}
				</div></div>
			</Modal>
		}
		{
			(commonNotice.heading == null || commonNotice.message == null) ? "" : <Modal className={themes[+themeToggle]}
				style={{ overlay: { zIndex: 100 }, content: { height: "min-content", background: "var(--second-bg)", borderRadius: "15px", boxShadow: "var(--wa-tenue)33 0px 8px 24px" } }}
				appElement={document.getElementById('root') as HTMLElement} isOpen
			>
				<div style={{ padding: "12px 15px 7px 15px" }}><div style={{ display: "table-row" }}>
					<div style={{ display: "table-cell", color: "var(--txt-color)", paddingTop: "5px", width: "100%" }}>
						{commonNotice.heading}
					</div>
					{
						commonNotice.cornerClose != true ? "" : <div style={{ display: "table-cell" }}><button type="button"
							className="button btn btn-default" onClick={() => dispatch(dismissNotice())} style=
							{{
								color: "var(--txt-color)",
								background: "var(--main-bg)",
								borderRadius: "50%",
								width: "35px",
								border: "1px solid var(--wa-filo-2)",
								padding: "2px 0px 0px 2px"
							}}
						>
							<FontAwesomeIcon icon={solid("times")} size="2x" />
						</button></div>
					}
				</div></div>
				<div style={{ padding: "30px", color: "var(--txt-color)" }}>
					{commonNotice.message}
					<br />
					<br />
					<div style={{ textAlign: "right" }}>
						{
							//Con la X arriba y nada que aceptar, el boton de abajo sobra: la X basta (Esteban, 2026-09-29).
							//"Rechazar" solo tiene sentido frente a un "Aceptar".
							(!commonNotice.cornerClose && commonNotice.procedure) || (commonNotice.cornerClose && !commonNotice.procedure) ? "" : <button className="btn btn-dark"
								type="button" onClick=
								{
									() => {
										dispatch(dismissNotice())

										if (commonNotice.optOutProcedure) {
											commonNotice.optOutProcedure()
										}
									}
								}
							>
								{!commonNotice.cornerClose ? "Cerrar" : "Rechazar"}
							</button>
						}
						{
							commonNotice.procedure == null ? "" : <button className="btn btn-light" type="button" onClick=
								{
									() => {
										commonNotice.procedure()
										dispatch(dismissNotice())
									}
								}
							>
								Aceptar
							</button>
						}
					</div>
				</div>
			</Modal>
		}
	</>
}

export default App